<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M13.4 16.6C14.2 17.4 14.2 18.6 13.4 19.4C13 19.8 12.5 20 12 20C11.5 20 11 19.8 10.6 19.4C9.8 18.6 9.8 17.4 10.6 16.6C11.4 15.8 12.6 15.8 13.4 16.6ZM12 12C13.6 12 15.1 12.6 16.2 13.8C16.6 14.2 16.6 14.8 16.2 15.2C16 15.4 15.7 15.5 15.5 15.5C15.2429 15.5 15.0592 15.4265 14.886 15.2796L14.8 15.2C13.3 13.7 10.8 13.7 9.3 15.2C8.9 15.6 8.3 15.6 7.9 15.2C7.53077 14.8308 7.50237 14.2911 7.81479 13.8957L7.9 13.8C8.9 12.6 10.4 12 12 12ZM12 8C14.6 8 17.1 9 18.9 10.9C19.3 11.3 19.3 11.9 18.9 12.3C18.7 12.5 18.5 12.6 18.2 12.6C17.9429 12.6 17.7592 12.5265 17.586 12.3796L17.5 12.3C16 10.8 14.1 10 12 10C9.9 10 8 10.8 6.5 12.3C6.1 12.7 5.5 12.7 5.1 12.3C4.7 11.9 4.7 11.3 5.1 10.9C6.9 9 9.4 8 12 8ZM12 4C15.7 4 19.1 5.5 21.7 8.1C22.1 8.5 22.1 9.1 21.7 9.5C21.5 9.7 21.3 9.8 21 9.8C20.7 9.8 20.5 9.7 20.3 9.5C18.1 7.2 15.1 6 12 6C8.9 6 5.9 7.2 3.7 9.5C3.3 9.9 2.7 9.9 2.3 9.5C1.9 9.1 1.9 8.5 2.3 8.1C4.9 5.5 8.3 4 12 4Z"
    fill="currentColor"
  />
</svg>
